import { useCallback, useRef, useState } from 'react'
import { resolveIsDarkMode } from './imageZoomUtils'
import { useImageZoomContainerObserver } from './image-zoom/useImageZoomContainerObserver'
import { useImageZoomGestures } from './image-zoom/useImageZoomGestures'
import { useImageZoomThemeObserver } from './image-zoom/useImageZoomThemeObserver'

type Params = {
  open: boolean
  minScale?: number
  maxScale?: number
}

export const useImageZoomViewer = ({ open, minScale = 1, maxScale = 3 }: Params) => {
  const containerRef = useRef<HTMLDivElement | null>(null)
  const containerSizeRef = useRef({ width: 0, height: 0 })
  const [, setThemeVersion] = useState(0)
  const bumpThemeVersion = useCallback(() => setThemeVersion((current) => current + 1), [])

  const isDarkMode = resolveIsDarkMode()

  const updateContainerSize = useCallback(() => {
    const el = containerRef.current
    if (!el) {
      containerSizeRef.current = { width: 0, height: 0 }
      return
    }
    containerSizeRef.current = { width: el.clientWidth, height: el.clientHeight }
  }, [])

  const gestures = useImageZoomGestures({
    minScale,
    maxScale,
    containerSizeRef,
  })

  useImageZoomContainerObserver({
    open,
    containerRef,
    containerSizeRef,
    updateContainerSize,
  })

  useImageZoomThemeObserver({
    open,
    onThemeChange: bumpThemeVersion,
  })

  return {
    containerRef,
    isDarkMode,
    ...gestures,
  }
}
